<div class="container container-default container-margin-top">
  <div class="text-center">
    <h1>Sorry!</h1>
    <h3>Der Voucher Code ist ungültig oder wurde bereits verwendet.</h3>
    <h3>Bitte wenden Sie sich an die Person, von der Sie den Code erhalten haben.</h3>
  </div>
</div>
